import { ProductName } from '../../../common/constants/products'
import { getActiveProduct } from './getActiveProductFromUrl'

/**
 * The product areas incident banners are scoped to. Finer-grained than
 * `ProductName`: Insights lives on the publish subdomain (`/insights/...`)
 * but is its own area on the status page mapping.
 */
export type AppArea =
  | 'publish'
  | 'create'
  | 'community'
  | 'insights'
  | 'settings'
  | 'analyze'
  | 'engage'
  | 'start-page'
  | 'account'

const PRODUCT_TO_AREA: Record<ProductName, AppArea> = {
  [ProductName.PUBLISH]: 'publish',
  [ProductName.CREATE]: 'create',
  [ProductName.COMMENTS]: 'community',
  [ProductName.NEWSETTINGS]: 'settings',
  [ProductName.ANALYZE]: 'analyze',
  [ProductName.ENGAGE]: 'engage',
  [ProductName.START_PAGE]: 'start-page',
  [ProductName.ACCOUNT]: 'account',
}

export function getActiveAppArea(): AppArea | null {
  const product = getActiveProduct()
  if (product === null) {
    return null
  }

  // Routes the PRODUCTS table doesn't know about fall back to PUBLISH in
  // `getActiveProduct`, but some of them are their own area: Insights
  // (`/insights/:channelId`) and Community's newer routes (`/community/...`
  // and a channel's `/channels/:channelId/community/...` view — the table
  // only knows the older `/comments` pathname).
  if (product.id === ProductName.PUBLISH) {
    const [, first, , third] = window.location.pathname.split('/')
    if (first === 'insights') {
      return 'insights'
    }
    if (
      first === 'community' ||
      (first === 'channels' && third === 'community')
    ) {
      return 'community'
    }
  }

  return PRODUCT_TO_AREA[product.id]
}
